import Carousel from 'components/Carousel/Carousel';

export default Carousel;
